/** Entity-page tab path for the Pulse content (relative to the entity base). */
export const ENTITY_PULSE_TAB_PATH = '/pulse';

/** Query parameter used to preselect a check within the Pulse entity tab. */
export const CHECK_QUERY_PARAM = 'check';

/**
 * Builds a deep link into an entity's Pulse tab. When `trackId` is provided the
 * link opens directly on that track's sub-tab; when `checkId` is provided it is
 * carried as a query parameter so the Pulse tab preselects that check (and, if
 * no track is given, resolves the track that contains it).
 */
export const buildEntityPulseHref = (
  entityBasePath: string,
  options: { trackId?: string; checkId?: string } = {},
): string => {
  const { trackId, checkId } = options;
  let path = `${entityBasePath}${ENTITY_PULSE_TAB_PATH}`;
  if (trackId) {
    path += `/${encodeURIComponent(trackId)}`;
  }
  if (checkId) {
    path += `?${CHECK_QUERY_PARAM}=${encodeURIComponent(checkId)}`;
  }
  return path;
};
